import { helpers } from 'vuelidate/lib/validators'
import moment from 'moment'

export default date =>
  helpers.withParams(
    { type: 'maxDate', max: date },
    function(value, parentVm) {
        var input = moment(moment(value).format("YYYY-MM-DD"))
        var reference = moment(moment(date).format("YYYY-MM-DD"))
        return !helpers.req(value) || input <= reference
    }
  )